import { HeroImage, StaticPageLoadingPlaceholder, useAnalyticsErrorPageTracker } from '@cp-shared-19/frontend-ui';
import React from 'react';
import { useLogin } from '../../../auth/useLogin';
import { withLoadingAndNoConnectionHandler } from '../../integration-wrapper';
import { landingPagePath } from '../../navigation/paths';
import { useUnauthorizedErrorPage } from './useUnauthorizedErrorPage';

export const UnauthorizedErrorPage: React.FC = () => {
    const { cmsContent: unauthorizedErrorPage, isLoading, loadingError } = useUnauthorizedErrorPage();

    const HeroImageWithHandlers = withLoadingAndNoConnectionHandler(HeroImage);

    useAnalyticsErrorPageTracker('unauthorizedError', !!unauthorizedErrorPage);
    const login = useLogin(landingPagePath);

    return (
        <HeroImageWithHandlers
            isLoading={isLoading}
            hasError={!!loadingError}
            pretitle={unauthorizedErrorPage?.pretitle}
            title={unauthorizedErrorPage?.title || ''}
            subTitle={unauthorizedErrorPage?.subTitle}
            buttonText={unauthorizedErrorPage?.buttonText}
            clickHandler={login}
            loadingPlaceholder={<StaticPageLoadingPlaceholder withHeroTeaser={false} />}
        />
    );
};
